var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.199951 2.59999C0.199951 1.38497 1.18492 0.399994 2.39995 0.399994H15.5999C16.815 0.399994 17.7999 1.38497 17.7999 2.59999V4.79999C16.5849 4.79999 15.5999 5.78497 15.5999 6.99999C15.5999 8.21502 16.5849 9.19999 17.7999 9.19999V11.4C17.7999 12.615 16.815 13.6 15.5999 13.6H2.39995C1.18492 13.6 0.199951 12.615 0.199951 11.4V9.19999C1.41498 9.19999 2.39995 8.21502 2.39995 6.99999C2.39995 5.78497 1.41498 4.79999 0.199951 4.79999V2.59999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.5a2189e0c61e05fa2cdd7ab70fa4e536.svg";
export { ForwardRef as ReactComponent };